module.exports = __webpack_public_path__ + "static/showroom_img-7a7ab3c0565ff1848555b87884b02b70.jpg";